/** Superfície compartilhada dos quadros interativos; dados e autorização ficam no domínio. */
import type { ReactNode } from 'react';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { ScrollIndicators } from '@/components/ui/scroll-indicators';

export function InteractiveKanbanBoard({ children }: { children: ReactNode }) {
  return <div className="min-h-0 min-w-0 flex-1 overflow-hidden">
    <ScrollIndicators className="h-full">
      <ScrollArea className="h-full w-full max-w-full" preventScrollChaining touchAxis="pan-x">
        <div className="flex h-[calc(100dvh-180px)] min-h-0 gap-4 p-4">{children}</div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </ScrollIndicators>
  </div>;
}